import React, {Component  } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/styles';
import { Field, reduxForm } from 'redux-form';
import { setPropsAsInitial } from '../helpers/setPropsAsInitial';
import { isMobile, isBrowser, isChrome } from 'react-device-detect';
import { Grid, Fab, Typography } from '@material-ui/core';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import LockIcon from '@material-ui/icons/Lock';
import PersonIcon from '@material-ui/icons/Person';
import { history } from '../helpers/history';

const useStyles = theme => ({
  paper: {

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%', // Fix IE 11 issue.
    //marginTop: 1,
    backgroundColor: "#0097a0",
    padding: "1% 6% 6% 6%",
    borderRadius: "8px",
    border: "3px solid #0097a0"
  },
  avatar: {
    margin: 1,
    backgroundColor: 'red',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    //marginTop: 1,

  },
  submit: {
    margin: (3, 0, 2),
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: 'white',
    backgroundColor: "#0097a0",
    "&:hover": {
      backgroundColor: "#0097a0"
    },
    borderRadius: "8px",
    border: "1px solid #fffffe"
  },
  logo: {
    width: '70%',
    height: '70%'
  },
  footer: {
    width: '5%',
    height: '5%'
  },
  button_header: {
    marginTop: 20,
  },
  grid_header: {
    marginTop: 10,
  },
  copyright: {
    justifyContent: 'space-between'
  },
  multilineColor:{
    color:'red'
  },
  root: {
    background: "red"
  },
  input: {
    color: "white"
  },
  title: {
    color: 'rgb(0, 0, 1)',
    fontWeight: 'bold',
    fontSize: '1.75rem'
  },
  button: {
    fontSize: '0.875rem',
    color: 'white',
    background: '#0097a0',
    "&:hover": {
      backgroundColor: "#0097a0"
    },
    borderRadius: "8px",
    border: "1px solid #fffffe"
  },
  line: {
    backgroundColor: '#009aa8',
    height: '1px',
    width: '100%'
}
});

const validate = values => {
  const error  = {}
  if (!values.email) {
      error.email = `El campo Email es obligatorio`
  }
  if (!values.password) {
    error.password = `El campo Contraseña es obligatorio`
  }
  return error
}

/* function Copyright(classes) {
  return (
    <div >
      <Grid container className= {classes.grid_header} justify="center" alignItems="center" direction="row">
          <img src={process.env.PUBLIC_URL + '/images/footer_cb.png'} alt="Logo" style= {{width: '70%'}} />
      </Grid>
    </div>
  );
} */



class Login extends Component {
  componentDidMount() {
    if (this.txt) {
      this.txt.focus();
    }
    if (isMobile && !isBrowser && !isChrome) {
        // console.log('estoy en un dispositivo')
    }
  }


  renderTextField = (
    { input, label, name, type, withFocus, meta: { touched, error }},
  ) => {

    return <div>
              <Grid container spacing={1} justify="center" alignItems="center" direction="column" >
                <Grid item xs={3} md={3}>
                  <span style={{color:'white', fontSize : "120%"}}>{label}</span>
                </Grid>
              </Grid>
              <div style = {{paddingTop : "10px"}}>
                <TextField
                        {...input}
                        type={!type ? "text" : type}
                        variant="standard"
                        margin="none"
                        autoComplete="off"
                        fullWidth
                        style={{backgroundColor: 'white', borderRadius: '0px'}}
                        InputLabelProps= {
                          {
                            style: { color: '#fffffe', fontSize : "120%"}
                          }
                        }
                        name={label}
                        id={label}
                        label={''}
                        ref={withFocus && (txt => { this.txt = txt;} ) }
                        inputProps = {{
                          style : {
                            borderLeft: '4px solid rgba(255, 198, 0)',
                            margin : "-3px",
                            paddingLeft : "5px"
                          }
                        }}
                        InputProps={{
                          style : {
                            height : "45px"
                          },
                          startAdornment: (
                            <InputAdornment position="start" style={{backgroundColor: '#FFFFFF'}}>

                            </InputAdornment>
                          ),
                        }}
                      />

              </div>

    </div>
  };

  renderTextFieldPassword = (
    { input, label, name, type, withFocus, meta: { touched, error }},
  ) => {
    return <div>
      <Grid container spacing={1} justify="center" alignItems="center" direction="column" >
        <Grid item xs={3} md={3}>
          <span style={{color:'white', fontSize : "120%"}}>{label}</span>
        </Grid>
      </Grid>
      <div style = {{paddingTop : "10px"}}>
        <TextField
          {...input}
          type={!type ? "text" : type}
          variant="standard"
          margin="normal"
          fullWidth
          style={{backgroundColor: 'white', marginTop: 0}}
          InputLabelProps= {
            {
              style: { color: '#ffc600' }
            }
          }
          name={label}
          id={label}
          label={''}
          ref={withFocus && (txt => { this.txt = txt;} ) }
          inputProps = {{
            style : {
              borderLeft: '4px solid rgba(255, 198, 0)',
              margin : "-3px",
              paddingLeft : "5px"
            }
          }}
          InputProps={{
            style : {
              height : "45px"
            },
            startAdornment: (
              <InputAdornment position="start" style={{backgroundColor: '#FFFFFF'}}>

              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  };
  render() {
    // const { classes, handleSubmit, submitting, pristine } = this.props;
    const { classes, handleSubmit, finguerprint, valid } = this.props;
    return (
      <div>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <br/>
            {
              isMobile ?
              <img src={process.env.PUBLIC_URL + '/images/session_line.png'} alt="Logo" style={{width: '80%', height: '80%'}}  /> :
              <img src={process.env.PUBLIC_URL + '/images/session_line.png'} alt="Logo" style={{width: '80%', height: '80%'}}   />
            }

            <br/>
            <br/>
            <Typography variant="h4" style={{color: '#ffc600', fontWeight: 'bold'}}>
                { `Empresas` }
            </Typography>
            <br/>
            <Typography variant="h5" style={{color: '#ffc600', fontWeight: 'bold'}}>
                { `bienvenido!` }
            </Typography>
            <br/>
            <form className={classes.form} onSubmit={handleSubmit} id="myForm">

              <Field
                withFocus
                style = { {
                  color: "red"
                }}
                // type="email"
                name="email"
                // type="email"
                component={this.renderTextField}
                label="Usuario"
              />
              <br/>
              <Field
                name="password"
                type="password"
                component={this.renderTextFieldPassword}
                label="Contraseña"
              />
              <br/>
              <Button
                type="submit"
                name="buttonSubmit"
                disabled={!valid}
                fullWidth
                variant="contained"
                color="primary"
                // className={classes.submit}
              >
                Iniciar sesión
              </Button>
              </form>
              {
                 (isMobile && !isBrowser && !isChrome) &&
                  <Grid container  justify="center" alignItems="center" direction="row">
                    <Box mt={2}>
                      <Fab color="primary" aria-label="add" onClick = { finguerprint } >
                        <FingerprintIcon />
                      </Fab>
                    </Box>
                  </Grid>
              }
              <Grid container className= {classes.grid_header}>
                <Grid item xs={12} sm={12}  className= {classes.button_header}>
                  <Button
                    fullWidth
                    onClick = { () => history.push('/password-recover')}
                    variant="contained"
                    color="primary"
                    // className={classes.button}
                    size= "medium"
                    //disabled = {true}
                    endIcon={<LockIcon></LockIcon>}
                    > Olvidó su contraseña</Button>
                </Grid>
                <Grid item xs={12} className= {classes.button_header}>
                  <Button
                    variant="contained"
                    onClick = {() =>  history.push('/user-recover')}
                    // className={classes.button}
                    fullWidth
                    //disabled = {true}
                    color="primary"
                    endIcon={<PersonIcon/>}
                    > Olvidó su usuario </Button>
                </Grid>
              </Grid>

          </div>
          <Box mt={3}>

          </Box>
        </Container>
      </div>
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  finguerprint: PropTypes.func.isRequired,
  email: PropTypes.string,
  password: PropTypes.string,
};

const LoginReduxForm = reduxForm(
  {
    form: 'Login',
    validate
  }
)(Login)
export default setPropsAsInitial(withStyles(useStyles)(LoginReduxForm))
